import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Downloader from "@/components/Downloader";
import TrustSection from "@/components/TrustSection";
import HowItWorks from "@/components/HowItWorks";
import Marquee from "@/components/Marquee";
import SeoContent from "@/components/SeoContent";
import Footer from "@/components/Footer";
import { useLang } from "@/context/LangContext";

const META = {
  ar: {
    title: "تحميل فيديو تيك توك بدون علامة مائية – مجاني بجودة HD",
    desc: "حمّل فيديوهات تيك توك بدون علامة مائية بجودة HD، واستخرج الصوت MP3. الصق الرابط وحمّل مباشرة من الجوال أو الكمبيوتر بدون تثبيت أي برنامج.",
    locale: "ar_AR",
  },
  en: {
    title: "Download TikTok Videos Without Watermark – Free HD",
    desc: "Download public TikTok videos without watermark in HD, or extract MP3 audio. Paste the link and download on mobile or desktop — nothing to install.",
    locale: "en_US",
  },
};

export default function Home() {
  const location = useLocation();
  const { lang, setLangForced } = useLang();

  useEffect(() => {
    const forced = location.pathname === "/en" || location.pathname === "/en/" ? "en" : "ar";
    if (forced !== lang) setLangForced(forced);
  }, [location.pathname, lang, setLangForced]);

  useEffect(() => {
    const isEn = location.pathname === "/en" || location.pathname === "/en/";
    const meta = META[isEn ? "en" : "ar"];
    const canonical = isEn ? "https://www.sstik1.com/en/" : "https://www.sstik1.com/";
    document.title = meta.title;

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", meta.desc);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.desc);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:locale"]', "content", meta.locale);
    setMeta('meta[name="twitter:title"]', "content", meta.title);
    setMeta('meta[name="twitter:description"]', "content", meta.desc);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [location.pathname]);

  return (
    <main data-testid="home-page" className="relative">
      <div className="bg-blobs" aria-hidden="true"><span /><span /><span /></div>
      <Navbar />
      <Hero />
      <Downloader />
      <TrustSection />
      <HowItWorks />
      <Marquee />
      <SeoContent />
      <Footer />
    </main>
  );
}
